import tokenFromLS from "./tokenFromLS";
import { handleSessionEnded } from "./impersonation";

class CBAPIClass {
  static API_URL = process.env.REACT_APP_API_URI;

  static async fetch(path, method = 'GET', params) {
    const resource = `${CBAPIClass.API_URL}/${path}`;
    const fetchOptions = {
      method: method,
      headers: {
        Authorization: `Bearer ${tokenFromLS()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
      },
    };

    if (method !== 'GET' && params) {
      fetchOptions.body = JSON.stringify(params);
    }

    try {
      const response = await fetch(resource, fetchOptions);
      
      // Check for 401 Unauthorized status
      if (response.status === 401) {
        // An expired impersonation goes back to the admin's own login
        if (handleSessionEnded()) {
          throw new Error('Impersonation ended - returning to admin account');
        }
        // Clear token from localStorage
        localStorage.removeItem('token');
        // Redirect to login page
        window.location.href = '/login';
        throw new Error('Unauthorized - redirecting to login');
      }
      
      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return response;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
}

export default CBAPIClass;